import { Offscreen } from '@deque/cauldron-react';
import React from 'react';

export interface LiveRegionAnnouncementProps {
  message: string | null | undefined;
  role?: 'status' | 'alert';
}

/**
 * Keeps a live region mounted so screen-reader announcements are reliable.
 * Assistive tech watches mutations to existing regions, while a region inserted
 * with text already inside is frequently not announced at all.
 */
const LiveRegionAnnouncement: React.FC<LiveRegionAnnouncementProps> = ({
  message,
  role = 'status'
}) => {
  return (
    <Offscreen>
      <span role={role}>{message ?? ''}</span>
    </Offscreen>
  );
};

export default LiveRegionAnnouncement;
